import { memo } from "react";

export const MoveWaveContent = memo(() => {
  return (
    <>
      Moving the time will impact all the routes allocated to this wave and also
      those in the next wave.
      <br />
      <br />
      Do you wish to continue?
    </>
  );
});
